import React from 'react';
import RydHeaderDialogBox from '../widgets/RydHeaderDialogBox';
import { normalizeClassName } from '../../render/renderUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGrip } from '@fortawesome/free-solid-svg-icons';
import {
    GridResolution,
    GridResolutionNames
} from '../../model/grid';


export function SnapToGridToggle({
    snap,
    setSnap
}: {
    snap: boolean,
    setSnap: (snap: boolean) => void
}) {
    return (<button className='flat-left'
        onClick={() => setSnap(!snap)}
        title="Snap to grid"
        style={snap ? {} : { backgroundColor: 'transparent' }}
    >
        <FontAwesomeIcon icon={faGrip} />
    </button>);
}

export function GridResolutionDialog({
    resolution,
    setResolution,
    snap,
    setSnap
}: {
    resolution: GridResolution,
    setResolution: (resolution: GridResolution) => void,
    snap: boolean,
    setSnap: (snap: boolean) => void
}) {

    const [collpased, setCollpased] = React.useState(true);

    if (collpased) {
        return (<>
            <button className={"flat-right"}
                onClick={() => setCollpased(false)}>
                Grid: {resolution}
            </button>
            <SnapToGridToggle snap={snap} setSnap={setSnap} />
        </>)
    }

    return (<>
        <RydHeaderDialogBox closeCB={() => setCollpased(true)}>
            <ul className={normalizeClassName(['midi-device-panel--list'])}>
                {GridResolutionNames.map((name, index) => (
                    <li
                        key={index}
                        className={normalizeClassName(
                            ['ryd-button-option'].concat(resolution === name ? ['ryd-button-option--active'] : [])
                        )}
                        onClick={() => {
                            setResolution(name as GridResolution);
                            setCollpased(true);
                        }}
                    >
                        {name}
                    </li>
                ))}
            </ul>
        </RydHeaderDialogBox>
        <SnapToGridToggle snap={snap} setSnap={setSnap} />
    </>);
}